import { render, staticRenderFns } from "./aiMail.vue?vue&type=template&id=6f1424a6&scoped=true"
import script from "./aiMail.vue?vue&type=script&lang=js"
export * from "./aiMail.vue?vue&type=script&lang=js"
import style0 from "./aiMail.vue?vue&type=style&index=0&id=6f1424a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1424a6",
  null
  
)

export default component.exports